import { useEffect, useState } from "react";
import { getRelativeTime } from "helpers/common";

const useRelativeTime = (timestamp, updateInterval = 10000) => {
  const [relativeTime, setRelativeTime] = useState(null);

  useEffect(() => {
    if (!timestamp) {
      setRelativeTime(null);
      return;
    }

    setRelativeTime(getRelativeTime(timestamp));
    const interval = setInterval(() => {
      setRelativeTime(getRelativeTime(timestamp));
    }, updateInterval);

    return () => clearInterval(interval);
  }, [timestamp]);

  return relativeTime;
}

export default useRelativeTime;